<template>
  <div v-if="flights&&flights.length>0">
    <div
      v-for="(info,index) in flights"
      :key="index"
      class="bg-white m-b-5"
    >
      <van-cell style="padding-bottom: 0; font-size: 12px;">
        <van-tag
          round
          class="tag-green"
        >
          <span v-show="index==0&&flights.length>1&&roundTrip==0||(flights.length==1&&travelType==2&&roundTrip==0)">{{ $t('C174','去程') }}</span>
          <span v-show="index==0&&flights.length==1&&travelType!=2">{{ $t('C101','单程') }}</span>
          <span v-show="index==1&&flights.length>1||(flights.length==1&&travelType==2&&roundTrip==1)">{{ $t('C175','返程') }}</span>
        </van-tag>
        {{ info.departDate }} {{ info.departDate |week }}
        <span > <van-icon name="clock-o" />  总时长{{ info.flyTimeStr||info.nFlyTime || durationo(info) }}</span>
        <slot name="right" />
      </van-cell>
      <!--  -->
      <div
        v-for="(ft,index1) in info.allFlightList"
        :key="index1"
      >
        <van-cell :border="false" style="padding: 0 16px;">
          <van-row>
            <van-col span="18">
              <van-row
                type="flex"
                align="center"
                class="font16 font-lg airport"
              >
                <van-col span="5">
                  {{ ft.departTime }}
                </van-col>
                <van-col span="2">
                  <van-icon
                    name="circle"
                    class="line-top"
                  />
                  <span class="line" />
                  <van-icon
                    name="circle"
                    class="line-bottom"
                  />
                </van-col>
                <van-col
                  span="17"
                  class="van-ellipsis"
                >
                  {{ ft.departCityName }} {{ ft.departAirportName|airportName }} {{ ft.departTerminal }}
                </van-col>
              </van-row>

              <van-row
                type="flex"
                align="center"
                class="font16 font-lg airport"
              >
                <van-col span="5">
                  {{ ft.arriveTime }}
                </van-col>
                <van-col span="2">
                  <van-icon
                    name="circle"
                    class="line-top"
                  />
                  <span class="line" />
                  <van-icon
                    name="circle"
                    class="line-bottom"
                  />
                </van-col>
                <van-col
                  span="17"
                  class="van-ellipsis"
                >
                  {{ ft.arriveCityName }} {{ ft.arriveAirportName |airportName }} {{ ft.arriveTerminal }}
                </van-col>
              </van-row>
            </van-col>
            <!-- <van-col
              span="6"
              class="font10 text-right"
            >
              <p><van-icon name="clock-o" />{{ ft.flyTimeStr }} </p>
              <p class="van-ellipsis">
                <img
                  class="airIcon"
                  :src="ft.airlineImg"
                >{{ ft.airlineName }}
              </p>
              {{ ft.flightNo }} | {{ ft.model }}
            </van-col> -->
          </van-row>
        
        </van-cell>
        <van-cell style="padding: 0 16px 10px 16px;">
          <van-row class='fontz gray'>
            <van-col>
              <p class="van-ellipsis">
                <img
                  class="airIcon"
                  :src="ft.airlineImg"
                >    {{ ft.airlineName }} |
                {{ ft.flightNo }} | {{ ft.model }}
              </p>
            </van-col>
          </van-row>
        </van-cell>
        <van-row
          v-if="index1==0&&info.transferAirportList&&info.transferAirportList.length>0"
          class="font10"
        >
          <van-col span="4" />
          <van-col>
            <div class="stopList font12 gray bg-gray">
              <span class="stop main-color">转</span>{{ $t('transfer','中转') }}
              <span
                v-for="(t,index2) in info.transferAirportList"
                :key="index2"
              >{{ t.transferCityName }}{{ t.transferTimeStr }}</span>
            </div>
          </van-col>
        </van-row>
      </div>
      <CollapseText :suggested="true" :transfer="transferboon"/>
    </div>
  </div>
</template>
<script>
import { Cell, Tag } from "vant";
import { duration } from "Utils/dateUtil";
import CollapseText from "Views/TkInt/components/collapsetext/index.vue";

export default {
  name:'TkIntVoyage',
  components:{
    [Cell.name]:Cell,
    [Tag.name]:Tag,
    CollapseText
  },
  props:{
    flights:{
      type:Array,
      default:function(){
        return []
      }
    },
    travelType:{
      type:[String,Number],
      default:'0'
    },
    roundTrip:{
      type:[String,Number],
      default:'0'
    }
  },
  data(){
    return {
            
    }
  },
  computed: {
    transferboon() {
      if ( this.flights[0].transferAirportList &&this.flights[0].transferAirportList.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods:{
    durationo(info){
      return duration(info)
    }
  }
}
</script>
<style lang="less" scoped>
    @import '~Assets/styles/business';

    .m-b-5{
        margin-bottom: 5px;
    }
    .airport{
        height: 36px;
    }
    .stopList{
        display: inline-block;
        padding: 2px 4px;
        border-radius: 18px;
        background-color: @color-background-lightGray;
    }
    .stop{
        display: inline-block;
        padding: 0 4px;
        border-radius: 8px;
        background-color: @color-background-white;
        font-size: @font-size-10;
    }
    .line{
         display: inline-block;
        position: absolute;
        top: 20px;
        bottom: 20px;
        width: 6px;
        border-right:1px solid #cccccc;
        height: calc(100% - 40px);
    }
    .line-bottom,.line-top{
        position: absolute;
        font-size: @font-size-10;
        color: #cccccc;
        background-color: @color-background-white;
    }
    .line-top{
        top: 10px;
    }
    .line-bottom{
        bottom: 10px;
    }
    .fontz {
      font-size: 12px;
    }
</style>